import { CoreSubject } from '../types';

export const findSubject = (subjects: CoreSubject[], id: string): CoreSubject | undefined => {
  if (!subjects || !Array.isArray(subjects)) return undefined;

  for (const s of subjects) {
    if (s.id === id) {
      return s;
    }
    if (s.subjects && s.subjects.length > 0) {
      const f = findSubject(s.subjects, id);
      if (f) {
        return f;
      }
    }
  }
  return undefined;
};

export const findSubjectsWithParent = (subjects: CoreSubject[], parentId: string): CoreSubject[] | undefined => {
  if (!subjects || !Array.isArray(subjects)) return undefined;

  for (const s of subjects) {
    if (s.id === parentId) {
      return s.subjects;
    }
    if (s.subjects && s.subjects.length > 0) {
      const f = findSubjectsWithParent(s.subjects, parentId);
      if (f) {
        return f;
      }
    }
  }
  return undefined;
};
